import './instrument.js'
import './app/polyfills.js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import ReactGA from 'react-ga4'
import { HelmetProvider } from 'react-helmet-async'

import router from './app/routesConfig.jsx'
import { AuthProvider } from './app/util/AuthContext.jsx'
import AppDispatcher from './app/dispatchers/AppDispatcher.js'

import './css/reset.css'
import 'react-day-picker/style.css'
import 'font-awesome/css/font-awesome.min.css'
import '@fontsource/source-sans-pro/400.css'
import '@fontsource/source-sans-pro/700.css'
import './css/app.css'

// Set up Google Analytics
if (import.meta.env.PROD) {
  ReactGA.initialize(import.meta.env.VITE_GA_ID, {
    debug: false,
  })
}

// Listen for route changes to track page views and save history
router.subscribe(({ location }) => {
  if (import.meta.env.PROD) {
    ReactGA.send({ hitType: 'pageview', page: `${location.pathname}` })
  }

  AppDispatcher.dispatch({
    action: 'save-history',
    path: `${location.pathname}`,
  })
})
const app = document.getElementById('app')
const root = createRoot(app)
root.render(
  <HelmetProvider>
    <AuthProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </AuthProvider>
  </HelmetProvider>
)
